export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-royal-deep border-t border-gold/30">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="inline-flex rounded-2xl bg-white px-4 py-3">
              <img
                src="/assets/oec-logo-brand.png"
                alt="One Energy Club logo"
                data-testid="footer-logo"
                className="h-12 w-auto"
              />
            </div>
            <p className="mt-5 max-w-xs text-sm text-white/70 leading-relaxed">
              Corporate events, media and experiential solutions — built for business, designed
              for connection.
            </p>
          </div>

          <div>
            <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-gold-bright">Explore</p>
            <nav className="mt-5 flex flex-col gap-3">
              {[
                { label: "Services", href: "#services" },
                { label: "Work Showcase", href: "#work" },
                { label: "About OEC", href: "#about" },
                { label: "Process", href: "#process" },
                { label: "Enquiry Form", href: "#enquiry" },
              ].map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="w-fit text-sm text-white/70 transition-colors duration-300 hover:text-gold-bright"
                >
                  {l.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-gold-bright">Contact</p>
            <a
              href="mailto:zeba@enersider.com"
              data-testid="footer-email-link"
              className="mt-5 inline-block text-sm text-white underline decoration-gold/60 underline-offset-4 transition-colors duration-300 hover:text-gold-bright"
            >
              zeba@enersider.com
            </a>
            <p className="mt-6 font-mono text-[10px] tracking-[0.25em] uppercase text-white/50">
              Powered by Enersider
            </p>
          </div>
        </div>

        <div className="mt-14 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-t border-gold/25 pt-7">
          <p className="text-xs text-white/55" data-testid="footer-copyright">
            © {year} One Energy Club. All rights reserved.
          </p>
          <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-white/55">
            Strategy · Creativity · Execution
          </p>
        </div>
      </div>
    </footer>
  );
}
